import { field, date, relation, json,text } from '@nozbe/watermelondb/decorators';
import { sanitizeImages } from '../../constants';
import { GUIDED_TOURS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class GuidedTour extends Model {
    static table = GUIDED_TOURS_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
    }

    @text('sub_module') sub_module;
    @text('step_name') step_name;
    @text('module') module;

    @date('updated_at') updated_at;

    @json('completed_steps', sanitizeImages) completed_steps;

    @relation('user', 'user_id') user;
};